import { Icon } from "@chakra-ui/react";
import React from "react";

/**
 * Renders the phone on icon
 * 
 * @param {Object} props - The props of the component
 * @returns The phone on icon
 */
const PhoneOn = (props) => (
  <Icon viewBox="0 0 29 12" fill="none" {...props}>
    <path d="M0.572155 5.98104C2.26354 4.28966 4.30334 2.98729 6.69157 2.07395C9.07981 1.1606 11.627 0.703928 14.3332 0.703928C17.0394 0.703928 19.5867 1.1606 21.9749 2.07395C24.3631 2.98729 26.4029 4.28966 28.0943 5.98104C28.3379 6.2246 28.4597 6.50875 28.4597 6.8335C28.4597 7.15824 28.3379 7.44239 28.0943 7.68595L24.8063 10.974C24.6168 11.1634 24.3834 11.2683 24.106 11.2886C23.8287 11.3089 23.5885 11.2446 23.3855 11.0958L20.0163 8.78197C19.7727 8.59253 19.5968 8.4031 19.4886 8.21366C19.3803 8.02423 19.3262 7.82126 19.3262 7.60477L19.3059 3.64693C18.5346 3.4169 17.7295 3.25453 16.8906 3.15981C16.0517 3.0651 15.1925 3.0245 14.3129 3.03804C13.474 3.03803 12.6452 3.08878 11.8266 3.19026C11.008 3.29174 10.1927 3.45073 9.38087 3.66723L9.38087 7.48299C9.38087 7.72655 9.31322 7.97687 9.17791 8.23396C9.0426 8.49105 8.86669 8.70078 8.65019 8.86315L5.28096 11.0958C5.0374 11.2311 4.7837 11.2886 4.51984 11.2683C4.25598 11.248 4.0361 11.1499 3.8602 10.974L0.572155 7.68595C0.328596 7.44239 0.206816 7.15824 0.206816 6.8335C0.206816 6.50875 0.328596 6.2246 0.572155 5.98104Z" fill="currentColor" />
  </Icon>
);

export default React.memo(PhoneOn);
